// extracted by css-extract-rspack-plugin
export default {"paper":"XL9mX"};